var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-99.000000, -8.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    transform: "translate(99.941125, 9.485365)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 9.99984492 7.13860822 9.99984492 7.13860822 0 0 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "7.98429019 0.000155084444 9.12892126 0.000155084444 9.12892126 10 7.98429019 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    points: "9.85536893 0.000155084444 11 0.000155084444 11 10 9.85536893 10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a0355a3034988e652b00c7fb5030def2.svg";
export { ForwardRef as ReactComponent };